import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import {NewEmployeeWizardState} from "../store/NewEmployeeWizardState";
import {decodeBase64} from "../utils/ReadFile";
import {FileResponseDto} from "../model/FileResponseDto";
import DriveFilePreviewLink from "../model/file/DriveFilePreviewLink";
import DriveFile from "../model/file/DriveFile";

class TemplateApi {

    public downloadTaxDeductionTemplate(): Promise<Blob> {
        const companyId = selectedCompanyStore.companyId;
        const fileRs: Promise<FileResponseDto> = Backend.get(`/api/v1/company/${companyId}/templates/tax-deduction`);
        return fileRs.then(({data}) => decodeBase64(data));
    }

    public downloadEmploymentContractTemplate(state: NewEmployeeWizardState): Promise<Blob> {
        const companyId = selectedCompanyStore.companyId;
        const fileRs: Promise<FileResponseDto> = Backend.post(`/api/v1/company/${companyId}/templates/employment-contract`, state);
        return fileRs.then(({data}) => decodeBase64(data));
    }

    public downloadBoardMemberContractTemplate(state: NewEmployeeWizardState): Promise<Blob> {
        const companyId = selectedCompanyStore.companyId;
        const fileRs: Promise<FileResponseDto> = Backend.post(`/api/v1/company/${companyId}/templates/board-member-contract`, state);
        return fileRs.then(({data}) => decodeBase64(data));
    }

    public getClientDocsTemplates(locale: string): Promise<DriveFile[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/templates/docs/${locale}`);
    }

    public getClientDocTemplatePreviewLink(locale: string, fileId: string): Promise<DriveFilePreviewLink> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/templates/docs/${locale}/${fileId}/preview-link`);
    }
}

export const templateApi = new TemplateApi();